/**
 * The CP-3 zod schemas that the frozen file exports only as values, re-exported WITH their TS type (ADR-0027 §4).
 * Not frozen; generated from cp3_contracts.ts (a schema added to CP-3 gets its lines here in the same PR).
 * The value is the same object; the type is exactly z.infer. Web (no zod) writes `import type { ForecastStatus } from
 * "@bsim/contracts"`. index.ts exports these names explicitly, which shadows the star export of the bare value.
 */
import type { z } from "zod";
import {
  AssessmentAnswer as AssessmentAnswerSchema, AssessmentAttempt as AssessmentAttemptSchema,
  AssessmentDetail as AssessmentDetailSchema, AssessmentItemView as AssessmentItemViewSchema,
  AssessmentPhase as AssessmentPhaseSchema, AssessmentSummary as AssessmentSummarySchema,
  BankStory as BankStorySchema, BoardTeamRow as BoardTeamRowSchema, CeoOverrideNote as CeoOverrideNoteSchema,
  CheckStreamEvent as CheckStreamEventSchema, CoachTurnView as CoachTurnViewSchema, CohortBoard as CohortBoardSchema,
  CohortMode as CohortModeSchema, CohortSettings as CohortSettingsSchema, ContentCatalog as ContentCatalogSchema,
  CroAttestation as CroAttestationSchema, CroObjection as CroObjectionSchema, DebriefDeck as DebriefDeckSchema,
  DebriefPickView as DebriefPickViewSchema, DebriefPicks as DebriefPicksSchema, DebriefSlide as DebriefSlideSchema,
  DraftView as DraftViewSchema, ErrorBody as ErrorBodySchema, ErrorCode as ErrorCodeSchema,
  EventCardFact as EventCardFactSchema, EventCardView as EventCardViewSchema, EventForTeam as EventForTeamSchema,
  EvidenceMatrix as EvidenceMatrixSchema, FinaleReplay as FinaleReplaySchema, FinaleView as FinaleViewSchema,
  ForecastBandRange as ForecastBandRangeSchema, ForecastInput as ForecastInputSchema,
  ForecastStatus as ForecastStatusSchema, Id as IdSchema, IdempotencyHeaders as IdempotencyHeadersSchema,
  IfMatchHeaders as IfMatchHeadersSchema, DecisionCatalogEntry as DecisionCatalogEntrySchema,
  MarketView as MarketViewSchema, MemberRole as MemberRoleSchema, Membership as MembershipSchema,
  NarrativeReviewItem as NarrativeReviewItemSchema, ObjectionSeverity as ObjectionSeveritySchema,
  PracticeResult as PracticeResultSchema, PreviewContext as PreviewContextSchema, Principal as PrincipalSchema,
  ProgramId as ProgramIdSchema, RationaleInput as RationaleInputSchema, RationaleView as RationaleViewSchema,
  RecognitionView as RecognitionViewSchema, Reflection as ReflectionSchema,
  RenderedNarrative as RenderedNarrativeSchema, RiskAppetiteLimit as RiskAppetiteLimitSchema,
  RoomScreenShow as RoomScreenShowSchema, RoomScreenView as RoomScreenViewSchema, RosterMember as RosterMemberSchema,
  RoundReport as RoundReportSchema, RoundStateS as RoundStateSSchema, RoundSummary as RoundSummarySchema,
  RunOfShow as RunOfShowSchema, ScoreDisplay as ScoreDisplaySchema, ScoreTier as ScoreTierSchema,
  SessionResponse as SessionResponseSchema, SoloDebrief as SoloDebriefSchema, SoloPhaseS as SoloPhaseSSchema,
  SoloRunState as SoloRunStateSchema, SubmissionSource as SubmissionSourceSchema,
  SubmissionSummary as SubmissionSummarySchema, TeamState as TeamStateSchema,
  TransitionResponse as TransitionResponseSchema, Ts as TsSchema, WelcomeCard as WelcomeCardSchema,
} from "./cp3_contracts";

export const AssessmentAnswer = AssessmentAnswerSchema;
export type AssessmentAnswer = z.infer<typeof AssessmentAnswerSchema>;
export const AssessmentAttempt = AssessmentAttemptSchema;
export type AssessmentAttempt = z.infer<typeof AssessmentAttemptSchema>;
export const AssessmentDetail = AssessmentDetailSchema;
export type AssessmentDetail = z.infer<typeof AssessmentDetailSchema>;
export const AssessmentItemView = AssessmentItemViewSchema;
export type AssessmentItemView = z.infer<typeof AssessmentItemViewSchema>;
export const AssessmentPhase = AssessmentPhaseSchema;
export type AssessmentPhase = z.infer<typeof AssessmentPhaseSchema>;
export const AssessmentSummary = AssessmentSummarySchema;
export type AssessmentSummary = z.infer<typeof AssessmentSummarySchema>;
export const BankStory = BankStorySchema;
export type BankStory = z.infer<typeof BankStorySchema>;
export const BoardTeamRow = BoardTeamRowSchema;
export type BoardTeamRow = z.infer<typeof BoardTeamRowSchema>;
export const CeoOverrideNote = CeoOverrideNoteSchema;
export type CeoOverrideNote = z.infer<typeof CeoOverrideNoteSchema>;
export const CheckStreamEvent = CheckStreamEventSchema;
export type CheckStreamEvent = z.infer<typeof CheckStreamEventSchema>;
export const CoachTurnView = CoachTurnViewSchema;
export type CoachTurnView = z.infer<typeof CoachTurnViewSchema>;
export const CohortBoard = CohortBoardSchema;
export type CohortBoard = z.infer<typeof CohortBoardSchema>;
export const CohortMode = CohortModeSchema;
export type CohortMode = z.infer<typeof CohortModeSchema>;
export const CohortSettings = CohortSettingsSchema;
export type CohortSettings = z.infer<typeof CohortSettingsSchema>;
export const ContentCatalog = ContentCatalogSchema;
export type ContentCatalog = z.infer<typeof ContentCatalogSchema>;
export const CroAttestation = CroAttestationSchema;
export type CroAttestation = z.infer<typeof CroAttestationSchema>;
export const CroObjection = CroObjectionSchema;
export type CroObjection = z.infer<typeof CroObjectionSchema>;
export const DebriefDeck = DebriefDeckSchema;
export type DebriefDeck = z.infer<typeof DebriefDeckSchema>;
export const DebriefPickView = DebriefPickViewSchema;
export type DebriefPickView = z.infer<typeof DebriefPickViewSchema>;
export const DebriefPicks = DebriefPicksSchema;
export type DebriefPicks = z.infer<typeof DebriefPicksSchema>;
export const DebriefSlide = DebriefSlideSchema;
export type DebriefSlide = z.infer<typeof DebriefSlideSchema>;
export const DraftView = DraftViewSchema;
export type DraftView = z.infer<typeof DraftViewSchema>;
export const ErrorBody = ErrorBodySchema;
export type ErrorBody = z.infer<typeof ErrorBodySchema>;
export const ErrorCode = ErrorCodeSchema;
export type ErrorCode = z.infer<typeof ErrorCodeSchema>;
export const EventCardFact = EventCardFactSchema;
export type EventCardFact = z.infer<typeof EventCardFactSchema>;
export const EventCardView = EventCardViewSchema;
export type EventCardView = z.infer<typeof EventCardViewSchema>;
export const EventForTeam = EventForTeamSchema;
export type EventForTeam = z.infer<typeof EventForTeamSchema>;
export const EvidenceMatrix = EvidenceMatrixSchema;
export type EvidenceMatrix = z.infer<typeof EvidenceMatrixSchema>;
export const FinaleReplay = FinaleReplaySchema;
export type FinaleReplay = z.infer<typeof FinaleReplaySchema>;
export const FinaleView = FinaleViewSchema;
export type FinaleView = z.infer<typeof FinaleViewSchema>;
export const ForecastBandRange = ForecastBandRangeSchema;
export type ForecastBandRange = z.infer<typeof ForecastBandRangeSchema>;
export const ForecastInput = ForecastInputSchema;
export type ForecastInput = z.infer<typeof ForecastInputSchema>;
export const ForecastStatus = ForecastStatusSchema;
export type ForecastStatus = z.infer<typeof ForecastStatusSchema>;
export const Id = IdSchema;
export type Id = z.infer<typeof IdSchema>;
export const IdempotencyHeaders = IdempotencyHeadersSchema;
export type IdempotencyHeaders = z.infer<typeof IdempotencyHeadersSchema>;
export const IfMatchHeaders = IfMatchHeadersSchema;
export type IfMatchHeaders = z.infer<typeof IfMatchHeadersSchema>;
export const DecisionCatalogEntry = DecisionCatalogEntrySchema;
export type DecisionCatalogEntry = z.infer<typeof DecisionCatalogEntrySchema>;
export const MarketView = MarketViewSchema;
export type MarketView = z.infer<typeof MarketViewSchema>;
export const MemberRole = MemberRoleSchema;
export type MemberRole = z.infer<typeof MemberRoleSchema>;
export const Membership = MembershipSchema;
export type Membership = z.infer<typeof MembershipSchema>;
export const NarrativeReviewItem = NarrativeReviewItemSchema;
export type NarrativeReviewItem = z.infer<typeof NarrativeReviewItemSchema>;
export const ObjectionSeverity = ObjectionSeveritySchema;
export type ObjectionSeverity = z.infer<typeof ObjectionSeveritySchema>;
export const PracticeResult = PracticeResultSchema;
export type PracticeResult = z.infer<typeof PracticeResultSchema>;
export const PreviewContext = PreviewContextSchema;
export type PreviewContext = z.infer<typeof PreviewContextSchema>;
export const Principal = PrincipalSchema;
export type Principal = z.infer<typeof PrincipalSchema>;
export const ProgramId = ProgramIdSchema;
export type ProgramId = z.infer<typeof ProgramIdSchema>;
export const RationaleInput = RationaleInputSchema;
export type RationaleInput = z.infer<typeof RationaleInputSchema>;
export const RationaleView = RationaleViewSchema;
export type RationaleView = z.infer<typeof RationaleViewSchema>;
export const RecognitionView = RecognitionViewSchema;
export type RecognitionView = z.infer<typeof RecognitionViewSchema>;
export const Reflection = ReflectionSchema;
export type Reflection = z.infer<typeof ReflectionSchema>;
export const RenderedNarrative = RenderedNarrativeSchema;
export type RenderedNarrative = z.infer<typeof RenderedNarrativeSchema>;
export const RiskAppetiteLimit = RiskAppetiteLimitSchema;
export type RiskAppetiteLimit = z.infer<typeof RiskAppetiteLimitSchema>;
export const RoomScreenShow = RoomScreenShowSchema;
export type RoomScreenShow = z.infer<typeof RoomScreenShowSchema>;
export const RoomScreenView = RoomScreenViewSchema;
export type RoomScreenView = z.infer<typeof RoomScreenViewSchema>;
export const RosterMember = RosterMemberSchema;
export type RosterMember = z.infer<typeof RosterMemberSchema>;
export const RoundReport = RoundReportSchema;
export type RoundReport = z.infer<typeof RoundReportSchema>;
export const RoundStateS = RoundStateSSchema;
export type RoundStateS = z.infer<typeof RoundStateSSchema>;
export const RoundSummary = RoundSummarySchema;
export type RoundSummary = z.infer<typeof RoundSummarySchema>;
export const RunOfShow = RunOfShowSchema;
export type RunOfShow = z.infer<typeof RunOfShowSchema>;
export const ScoreDisplay = ScoreDisplaySchema;
export type ScoreDisplay = z.infer<typeof ScoreDisplaySchema>;
export const ScoreTier = ScoreTierSchema;
export type ScoreTier = z.infer<typeof ScoreTierSchema>;
export const SessionResponse = SessionResponseSchema;
export type SessionResponse = z.infer<typeof SessionResponseSchema>;
export const SoloDebrief = SoloDebriefSchema;
export type SoloDebrief = z.infer<typeof SoloDebriefSchema>;
export const SoloPhaseS = SoloPhaseSSchema;
export type SoloPhaseS = z.infer<typeof SoloPhaseSSchema>;
export const SoloRunState = SoloRunStateSchema;
export type SoloRunState = z.infer<typeof SoloRunStateSchema>;
export const SubmissionSource = SubmissionSourceSchema;
export type SubmissionSource = z.infer<typeof SubmissionSourceSchema>;
export const SubmissionSummary = SubmissionSummarySchema;
export type SubmissionSummary = z.infer<typeof SubmissionSummarySchema>;
export const TeamState = TeamStateSchema;
export type TeamState = z.infer<typeof TeamStateSchema>;
export const TransitionResponse = TransitionResponseSchema;
export type TransitionResponse = z.infer<typeof TransitionResponseSchema>;
export const Ts = TsSchema;
export type Ts = z.infer<typeof TsSchema>;
export const WelcomeCard = WelcomeCardSchema;
export type WelcomeCard = z.infer<typeof WelcomeCardSchema>;
